import PropTypes from 'prop-types';
import React from 'react';

const MyParishAppPostPostviewPropType = {
  toAllMembers: PropTypes.bool.isRequired,
  content: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  profilePic: PropTypes.string.isRequired,
  profileName: PropTypes.string.isRequired,
};

export default MyParishAppPostPostviewPropType;
